// ABOUTME: The sky scene behind 5C and 5D: 5C gets the forgiven sky, 5D draws its own and gets nothing here; the default is the cream sky and sun. No cloud stack.
// ABOUTME: The sun is scenery, always drawn; nothing in it moves, so there is no motion to reduce.

import { Box } from '@mui/material';
import OceanScene from '../../crossing/OceanScene';
import ForgivenSkyScene from './ForgivenSkyScene';
import { CROSSING_SUN_FILL, CROSSING_SUN_GLOW } from '../../../../theme/crossingTokens';

interface SkySceneProps {
  forgiven?: boolean;
  summary?: boolean; // 5D draws its own sky and sea, so the scenery draws nothing
}

export default function SkyScene({ forgiven, summary }: SkySceneProps) {
  if (summary) return null;
  if (forgiven) return <ForgivenSkyScene />;
  return (
    <>
      <OceanScene />
      <Box
        aria-hidden
        data-testid="sky-scene-sun"
        sx={{
          position: 'fixed', zIndex: -1, left: '71%', top: '9%', width: 40, height: 40,
          borderRadius: '50%', backgroundColor: CROSSING_SUN_FILL, boxShadow: CROSSING_SUN_GLOW,
        }}
      />
    </>
  );
}
